<template>
  <li class="nav-title">
    {{name}}
  </li>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SidebarNavTitle.vue